export const DIRECTION_OPTIONS = [
  { value: 'SELL', label: 'Sell (receivable)' },
  { value: 'BUY', label: 'Buy (payable)' },
];

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'CONVERTED', label: 'Converted' },
  { value: 'CANCELLED', label: 'Cancelled' },
];

export const DIRECTION_FILTER_OPTIONS = [
  { value: '', label: 'All directions' },
  { value: 'SELL', label: 'Sell' },
  { value: 'BUY', label: 'Buy' },
];

export const TRADE_MODE_OPTIONS = [
  { value: 'spread', label: 'Buy + Sell (spread)' },
  { value: 'single', label: 'Single leg only' },
];

export const COUNTERPARTY_TYPE_OPTIONS = [
  { value: 'PARTNER', label: 'Partner' },
  { value: 'SUPPLIER', label: 'Supplier' },
  { value: 'OTHER', label: 'Other (free text)' },
];

export const PRODUCT_SEARCH_MIN = 1;
export const PARTNER_SEARCH_MIN = 2;
export const SUPPLIER_SEARCH_MIN = 3;
